import dayjs from 'dayjs';
import 'dayjs/locale/tr';
import { createTheme, Theme } from '@mui/material/styles';
import i18n, { AppLanguage } from '../i18n';
import { langDef, resolveLanguage, LanguageDef } from '../i18n/languages';

/** Current UI language */
export function getLanguage(): AppLanguage {
  return resolveLanguage(i18n.language);
}

/** Settings of the current UI language (locale tag, direction, date libraries) */
export function getLanguageDef(): LanguageDef {
  return langDef(getLanguage());
}

/** BCP 47 tag for Intl / toLocale* formatting of the UI language */
export function getLocale(): string {
  return getLanguageDef().locale;
}

/** date-fns locale object for the UI language */
export function getDateFnsLocale() {
  return getLanguageDef().dateFns;
}

/** A theme with MUI's built-in texts, date picker texts and text direction of the UI language */
export function localizeTheme(theme: Theme): Theme {
  const def = getLanguageDef();
  return createTheme(theme, { direction: def.dir }, def.mui, def.pickers);
}

// Some Google Ads pages switch dayjs' global locale when they load. Only once a page has asked
// for that does a language change also move dayjs, so other dayjs users keep their behaviour.
let dayjsPinned = false;

/** Set dayjs' global locale to the UI language and keep it in step with later changes */
export function pinDayjsLocale() {
  dayjsPinned = true;
  dayjs.locale(getLanguageDef().dayjs);
}

i18n.on('languageChanged', () => {
  if (dayjsPinned) dayjs.locale(getLanguageDef().dayjs);
});
